import { render } from "./CfNumberFilter.vue?vue&type=template&id=580929a4&scoped=true"
import script from "./CfNumberFilter.vue?vue&type=script&lang=js"
export * from "./CfNumberFilter.vue?vue&type=script&lang=js"

import "./CfNumberFilter.vue?vue&type=style&index=0&id=580929a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580929a4"]])

export default __exports__